import { render, staticRenderFns } from "./Details.htm?vue&type=template&id=55c5ecef&scoped=true&"
import script from "./Details.ts?vue&type=script&lang=js&"
export * from "./Details.ts?vue&type=script&lang=js&"
import style0 from "./Details.scss?vue&type=style&index=0&id=55c5ecef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c5ecef",
  null
  
)

export default component.exports